import BaseChannel from "~/channels/BaseChannel";

export default class LegacyUserChannel extends BaseChannel {
  static channelName = "LegacyUserChannel";
}
